import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { OtherService } from 'src/app/Service/other.service';
import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import axios from 'src/app/Service/axios';
import * as XLSX from 'xlsx';
declare let $: any;

@Component({

  selector: 'app-scrap-cars',

  templateUrl: './scrap-cars.component.html',

  styleUrls: ['./scrap-cars.component.css']

})

export class ScrapCarsComponent implements OnInit {

  lst_Scrap_Cars: any = [];

  lst_Search: any = [];

  carWork: any = [];

  carType: any = [];

  bEditMode: boolean = false;

  showFilter: boolean = false;

  mdl_Search: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

  })

  mdl_Scrap: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strUnitID: new FormControl('', Validators.required),

    strVIN: new FormControl('', Validators.required),

    strColor: new FormControl(''),

    iMobile_Abortion: new FormControl(''),

    iYearConstruction: new FormControl('', Validators.required),

    tiGPSType: new FormControl('', Validators.required),

    tiMobileType: new FormControl('', Validators.required),

    tiFuelType: new FormControl('1'),

    strVehicleType: new FormControl(''),

    iCylinderVolume: new FormControl(''),

    strChassisNumber: new FormControl('', Validators.required),

    strEngineNumber: new FormControl('', Validators.required),

    tiWheels: new FormControl(''),

    tiAxis: new FormControl(''),

    tiCylinders: new FormControl(''),

    strDate: new FormControl('', Validators.required),

    _index: new FormControl(''),

  })

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private router: Router,

    private _route: ActivatedRoute,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.get_ScrapCars();

  }

  get_ScrapCars = async () => {

    this._otherService.Showspinner();

    const resp = await axios.post(`Mobile_Abortion_List`, this._otherService.stringNumberToNumber(this.mdl_Search.value));

    let res = JSON.parse(resp.data);

    this.lst_Scrap_Cars = res;

    this.lst_Search = res;

    // // // / / / / / / / / / / / / / / / / / / / / / / / / / / 

    const resp3 = await axios.post(`GetMobileType`);

    this.carWork = resp3.data;

    // // // / / / / / / / / / / / / / / / / / / / / / / / / / / 

    const resp2 = await axios.post(`GetGPSType`);

    this.carType = resp2.data;

    this._otherService.nonespinner();

  }

  filter_list(val: any) {

    this.lst_Scrap_Cars = this.lst_Search.filter((el: any) => {

      return el.strMobileType_strComment.includes(val.value) ||

        el.iYearConstruction.toString().includes(val.value) ||

        el.strGPSType_strComment.includes(val.value) ||

        el.strVehicleType.includes(val.value) ||

        el.strGPSType_strComment.includes(val.value)


    });

    if (val.value.trim() == '') {

      this.lst_Scrap_Cars = this.lst_Search;

    }

  }

  openScrap_Modal(item?: any, index?: number) {

    if (item) {

      Object.keys(item).forEach(key => {

        this.mdl_Scrap.get(key)?.setValue(item[key])

      })

      this.mdl_Scrap.controls['_index'].setValue(index)

      this.bEditMode = true;

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      $("#Scrap_Modal").modal("show")

    }

    else {

      this.mdl_Scrap.patchValue({

        strUnitID: '',

        strVIN: '',

        strColor: '',

        iMobile_Abortion: '',

        iYearConstruction: '',

        tiGPSType: '',

        tiMobileType: '',

        tiFuelType: 1,

        strVehicleType: '',

        iCylinderVolume: '',

        strChassisNumber: '',

        strEngineNumber: '',

        tiWheels: '4',

        tiAxis: '2',

        tiCylinders: '',

        strDate: '',

      })

      this.showFilter = false;

      setTimeout(() => {

        this.showFilter = true;

      }, 10);

      this.bEditMode = false;

      $("#Scrap_Modal").modal("show")

    }

  }

  submit_Scrap = async () => {

    if (this.mdl_Scrap.invalid) return this._tooltip.showError('موارد ضروری را وارد کنید')

    if (!this.bEditMode) {

      this._otherService.Showspinner();

      const resp = await axios.post(`Mobile_Abortion_Save`, this._otherService.stringNumberToNumber(this.mdl_Scrap.value));

      let res = JSON.parse(resp.data);

      this._otherService.nonespinner();

      if (res.bError) return this._tooltip.showError(res.strError);

      this._tooltip.showSuccess('عملیات با موفقیت انجام شد')

      this.lst_Scrap_Cars.push(res[0])

      $("#Scrap_Modal").modal("hide")

    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              const resp = await axios.post(`Mobile_Abortion_Update`, this._otherService.stringNumberToNumber(this.mdl_Scrap.value));

              let res = JSON.parse(resp.data);

              this._otherService.nonespinner();

              if (res.bError) return this._tooltip.showError(res.strError);

              this.lst_Scrap_Cars[this.mdl_Scrap.get('_index')?.value] = res[0];

              $("#Scrap_Modal").modal("hide");

              this._tooltip.showSuccess('عملیات با موفقیت انجام شد');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  remove_Scrap(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iMobile_Abortion: item.iMobile_Abortion,

              iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(window.localStorage.getItem('Session')!),

            }

            this._otherService.Showspinner();

            const resp = await axios.post(`Mobile_Abortion_Delete`, model);

            this._otherService.nonespinner();

            let res = JSON.parse(resp.data);

            if (res.bError || res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_Scrap_Cars.splice(index, 1);

            return this._tooltip.showSuccess('اطلاعات با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",


        }

      }

    });

  }

  returnStrValue(strKey: string, strKeyValue: number | string, lst_: [] | any, strComment: string): string {

    return this._otherService.initialFilterValue(strKey, strKeyValue, lst_, strComment);

  }


}
